import store from '../../../store';
export default function checkIfCanDeleteQuestions() {
  let exists = false;
  let scopes = store.getters.userScopes;
  exists = scopes.includes('manage_questions_delete');
  return exists;
}
